import React, { useState } from 'react';
import {
	DatePicker,
	TextField,
	AdapterDateFns,
	LocalizationProvider,
} from 'components/mui';

const MuiDatePicker = ({ label, value, onChange }) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DatePicker
				label={label}
				value={value}
				onChange={(newValue) => {
					onChange(newValue);
				}}
				views={['year', 'month']} // Only show year and month views
				openTo="month" // Open to the month view by default
				format="MMMM yyyy" // Display format: "Month Year"
				renderInput={(params) => <TextField {...params} />}
			/>
		</LocalizationProvider>
	);
};

export default MuiDatePicker;
